import { toast as hotToast } from 'react-hot-toast';
import Icon from '../AppIcon';

const createToast = (type, message, options = {}) => {
  const icons = {
    success: 'CheckCircle',
    error: 'XCircle',
    warning: 'AlertTriangle',
    info: 'Info',
    loading: 'Loader'
  };

  const colors = {
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6',
    loading: '#6366f1'
  };

  return hotToast?.custom(
    (t) => (
      <div
        className={`
          flex items-start gap-3 p-4 rounded-lg shadow-lg border
          bg-card border-border
          transition-all duration-300
          ${t?.visible ? 'animate-in slide-in-from-top-5' : 'animate-out slide-out-to-top-5'}
        `}
      >
        <div 
          className="flex-shrink-0 w-5 h-5 flex items-center justify-center"
          style={{ color: colors?.[type] }}
        >
          <Icon name={icons?.[type]} size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-foreground">{message}</p>
          {options?.description && (
            <p className="text-xs text-muted-foreground mt-1">{options?.description}</p>
          )}
        </div>
        {options?.action && (
          <button
            onClick={() => {
              options?.action?.onClick();
              hotToast?.dismiss(t?.id);
            }}
            className="text-xs font-semibold text-primary hover:text-primary/80 transition-colors flex-shrink-0"
          >
            {options?.action?.label}
          </button>
        )}
        <button
          onClick={() => hotToast?.dismiss(t?.id)}
          className="text-muted-foreground hover:text-foreground transition-colors flex-shrink-0"
          aria-label="Dismiss"
        >
          <Icon name="X" size={16} />
        </button>
      </div>
    ),
    {
      duration: options?.duration || 4000,
      position: options?.position || 'top-right',
      ...options
    }
  );
};

export const toast = {
  success: (message, options) => createToast('success', message, options),
  error: (message, options) => createToast('error', message, options),
  warning: (message, options) => createToast('warning', message, options),
  info: (message, options) => createToast('info', message, options),
  loading: (message, options) => createToast('loading', message, options),
  promise: hotToast?.promise,
  dismiss: hotToast?.dismiss
};

export default toast;